import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FcHighPriority, FcList } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const SubmenuFinancePage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Keuangan",
    });
  }, [setHeader]);
  return (
    <div className="tw-p-4 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)}
            className="tw-m-0"
          >
            <FcHighPriority
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="tw-mt-0 card-name">Tagihan Bulanan</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)}
            className="tw-m-0"
          >
            <FcHighPriority
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="tw-mt-0 card-name">Tagihan Non Bulanan</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.DEBT_BILL_PAGE)}
            className="tw-m-0"
          >
            <FcHighPriority
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="tw-mt-0 card-name">Utang</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
            className="tw-m-0"
          >
            <FcList className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Rekening Koran</div>
          </div>
        </div>
      </div>
    </div>
  );
};
